import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  websocket: "",
  notification: JSON.parse(localStorage.getItem("notifications")) || [],
  payrollRefresh: false
};

const webSocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    setWebSocket: (state, action) => {
      state.websocket = action.payload;
    },
    addNotifications: (state, action) => {
      state.notification.push(action.payload);
      localStorage.setItem("notifications", JSON.stringify(state.notification));
    },
    triggerPayrollRefresh: (state) => {
      state.payrollRefresh = true;
    },
    resetPayrollRefresh: (state) => {
      state.payrollRefresh = false;
    },
    clearNotifications: (state) => {
      state.notification = [];
      state.websocket = "";
      localStorage.removeItem("notifications");
      localStorage.removeItem("encryptedWebSocketUrl");
    },
  },
});

export const { setWebSocket, addNotifications, clearNotifications, triggerPayrollRefresh, resetPayrollRefresh } = webSocketSlice.actions;
export default webSocketSlice.reducer;
